import { render, staticRenderFns } from "./CompanyContent.vue?vue&type=template&id=6f821104&scoped=true&"
import script from "./CompanyContent.vue?vue&type=script&lang=js&"
export * from "./CompanyContent.vue?vue&type=script&lang=js&"
import style0 from "./CompanyContent.vue?vue&type=style&index=0&id=6f821104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f821104",
  null
  
)

export default component.exports